import { render, staticRenderFns } from "./artifact-page.vue?vue&type=template&id=afc1615a&scoped=true"
import script from "./artifact-page.vue?vue&type=script&lang=js"
export * from "./artifact-page.vue?vue&type=script&lang=js"
import style0 from "./artifact-page.vue?vue&type=style&index=0&id=afc1615a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc1615a",
  null
  
)

export default component.exports